import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  /**
   * Estado actual del sidenav (abierto o cerrado).
   */
  sidenavOpened: boolean = true;
}
